import React from 'react';
import { useEssentials } from '../../contexts/essentials-context';
import { Box, Text } from '@wix/design-system';
import { Badge } from '.';

interface AppBenefitsBadgeProps {
  showBorder?: boolean;
  appName: string;
  size?: 'tiny' | 'small' | 'medium';
}

export function AppBenefitsBadge({
  showBorder,
  appName,
  size = 'small',
}: AppBenefitsBadgeProps) {
  const { t } = useEssentials();

  return (
    <Badge
      skin="neutralSuccess"
      dataHook="app-benefit-badge"
      uppercase={false}
      showBorder={showBorder}
      size={size}
      tooltipContent={
        <Box direction="vertical" gap="6px">
          {/* @ts-expect-error wds types are incompatible */}
          <Text size="small" weight="thin" skin="light">
            {t('app.benefits.badge.tooltip', { appName })}
          </Text>
        </Box>
      }
    >
      <Box marginTop="2px">{t('app.benefits.badge')}</Box>
    </Badge>
  );
}
